/* eslint-disable react/prop-types */
import TextField from '@mui/material/TextField'

function ReasonField({ value, onChange }) {
  return (
    <TextField
      label="Motivo"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth
      required
      multiline
      minRows={2}
      margin="normal"
      helperText="Descreva o motivo da alteração. Obrigatório e registrado em log."
    />
  )
}

export default ReasonField
